import { useMemo, useState } from "react";
import { Button } from "V2.0/common/button";
import { Switch } from "V2.0/common/switch";
import InputComponent from "V2.0/components/InputComponent";

function NeutralFillersEnableSwitch(props) {
  const { isFillersEnabled, onUpdate, disabled } = props;

  function handleUpdateFillersEnabled() {
    onUpdate({
      fillersEnabled: !isFillersEnabled,
    });
  }

  return (
    <Switch
      color="green"
      disabled={disabled}
      checked={isFillersEnabled}
      onChange={handleUpdateFillersEnabled}
    />
  );
}

export default function NeutralFillers(props) {
  const { voiceCache, onSave, locked } = props;

  const [settings, setSettings] = useState({
    fillersEnabled: voiceCache.fillersEnabled,
    neutralFillers: voiceCache.neutralFillers,
  });

  function handleUpdate(updatedSetting) {
    setSettings((prevSettings) => {
      return {
        ...prevSettings,
        ...updatedSetting,
      };
    });
  }

  function handleUpdateNeutralFillers(e) {
    setSettings((prevSettings) => {
      return {
        ...prevSettings,
        neutralFillers: e.target.value,
      };
    });
  }

  function handleSave() {
    const transformedResponses = Array.isArray(settings.neutralFillers)
      ? settings.neutralFillers
      : settings.neutralFillers.split(",");
    onSave({
      ...settings,
      neutralFillers: transformedResponses,
    });
  }

  return (
    <div className="border rounded-lg w-full">
      <div className="bg-gray-50 px-6 py-4 rounded-t-lg space-y-2">
        <p className="text-base font-medium">Neutral Fillers</p>
        <p className="text-sm text-gray-500">
          Short natural words (e.g., “hmm,” “okay...”) the assistant uses while
          thinking or waiting.
        </p>
      </div>
      <div className="px-8 py-4 grid grid-cols-3 space-y-4">
        <div className="col-span-3 flex items-center gap-x-2">
          <p className="font-medium">Use Neutral Fillers</p>
          <NeutralFillersEnableSwitch
            isFillersEnabled={settings.fillersEnabled}
            onUpdate={handleUpdate}
            disabled={locked}
          />
        </div>

        <div className="col-span-3 xl:col-span-2 ml-4">
          <InputComponent
            type="textArea"
            label="Enter Fillers (comma-seperated)"
            placeholder="Hmm...,Okay...,Sure..."
            disabled={locked || !settings.fillersEnabled}
            onChange={handleUpdateNeutralFillers}
            value={settings.neutralFillers}
            style={{ height: "100px", fontSize: "13px" }}
          />
        </div>
      </div>
      <div className="bg-gray-50 px-6 py-3 text-right rounded-b-lg">
        {!locked && <Button onClick={handleSave}>Save</Button>}
      </div>
    </div>
  );
}
